export default __webpack_public_path__ + "static/media/zabala1_g.86fc9d4d.jpg";